import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=84a270ce&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=ts"
export * from "./Setting.vue?vue&type=script&lang=ts"
import style0 from "./Setting.vue?vue&type=style&index=0&id=84a270ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a270ce",
  null
  
)

export default component.exports